import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Amruthavanam.css";

// HERO IMAGE
import heroImg from "../assets/Amruthavanam-Logo.png";

// WELCOME IMAGES
import w1 from "../assets/amruthavanam2.JPG";
import w2 from "../assets/amruthavanam9.JPG";
import w3 from "../assets/amruthavanam10.JPG";

// VISION & MISSION IMAGES
import vm1 from "../assets/amruthavanam3.JPG"; // Mission
import vm2 from "../assets/amruthavanam6.JPG"; // Vision

// GALLERY IMAGES
import g1 from "../assets/amruthavanam1.JPG";
import g2 from "../assets/amruthavanam4.JPG";
import g3 from "../assets/amruthavanam9.JPG";
import g4 from "../assets/amruthavanam7.JPG";
import g5 from "../assets/amruthavanam8.JPG";
import g6 from "../assets/amruthavanam10.JPG";
import g7 from "../assets/amruthavanam11.JPG";
import g8 from "../assets/amruthavanam12.JPG";
import g9 from "../assets/amruthavanam13.JPG";
import pamphletFront from "../assets/Amruthavanam-front.jpeg";
import pamphletBack from "../assets/amruthavanam-back.jpeg";

export default function Amruthavanam() {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <div className="agri-page">

      <section className="agri-hero">
        <div className="hero-container">

          {/* LEFT IMAGE */}
          <div className="hero-image" data-aos="fade-right">
            <img src={heroImg} alt="Amruthavanam" />
          </div>

          {/* RIGHT TEXT */}
          <div className="hero-text" data-aos="fade-left">
            <h1>Amruthavanam</h1>
            <h2>Agri Farm School</h2>
            <p>Learning Beyond Classrooms Into Nature 🌱</p>
            <button 
              className="hero-btn"
              onClick={() => navigate("/contact")}
            >
              Get In Touch
            </button>
          </div>

        </div>
      </section>

      {/* WELCOME */}
      <section className="agri-section">
        <h2 className="section-title" data-aos="fade-up">Welcome</h2>

        <p data-aos="fade-up">
          Welcome to Amrutha Vanam Agri Farm School. Our Agri Farm School takes pride
          in creating a wonderful learning environment for students who are eager
          to learn about farming and cultivation.
        </p>

        <p data-aos="fade-up" data-aos-delay="100">
          We encourage students to enjoy the learning process by actively involving
          themselves in practical farming activities. Students gain real time exposure
          to agricultural practices and develop a deeper understanding of nature and sustainability.
        </p>

        <p data-aos="fade-up" data-aos-delay="200">
          We provide quality learning experiences through hands-on activities such as
          cultivation, dairy farming, organic farming, and eco-friendly practices.
          Our programs are designed for schools, colleges, families, and corporate groups.
        </p>

        {/* IMAGES */}
        {/* IMAGES */}
<div className="welcome-images">
  {[w1, w2, w3].map((img, i) => (
    <div className="carousel-item" key={i}>
      <img src={img} alt={`Farm activity ${i + 1}`} />
    </div>
  ))}
</div>
      </section>

      {/* VISION & MISSION */}
      <section className="vm-section">

        <div className="vm-row">
          <div className="vm-text" data-aos="fade-right">
            <h2>Our Vision</h2>
            <ul>
              <li>Help people understand where food comes from</li>
              <li>Highlight the importance of farmers in our lives</li>
              <li>Promote farming as a valuable profession</li>
              <li>Encourage youth towards agriculture</li>
              <li>Ensure proper use of natural resources</li>
              <li>Reduce food scarcity and malnutrition</li>
              <li>Maintain balance between population & food production</li>
              <li>Give identity and respect to farmers</li>
            </ul>
          </div>
          <div className="vm-image" data-aos="fade-left">
            <img src={vm2} alt="Vision" />
          </div>
        </div>

        <div className="vm-row reverse">
          <div className="vm-text" data-aos="fade-left">
            <h2>Our Mission</h2>
            <ul>
              <li>Educate students about agriculture processes</li>
              <li>Teach farming from ploughing to harvesting</li>
              <li>Provide hands-on practical learning</li>
              <li>Introduce modern farming techniques</li>
              <li>Promote organic farming</li>
              <li>Expose students to rural environment</li>
              <li>Guide students under expert supervision</li>
              <li>Inspire youth to take agriculture as a career</li>
            </ul>
          </div>
          <div className="vm-image" data-aos="fade-right">
            <img src={vm1} alt="Mission" />
          </div>
        </div>

      </section>

      {/* PROGRAMS */}
      <section className="agri-section programs">
        <h2 className="section-title" data-aos="fade-up">Our Programs</h2>

        <div className="program-grid">
          <div className="program-card" data-aos="zoom-in">
            <h3>🌿 School Programs</h3>
            <p>For Nursery to Class X students with hands-on farming activities.</p>
          </div>

          <div className="program-card" data-aos="zoom-in" data-aos-delay="100">
            <h3>🏫 College Visits</h3>
            <p>Educational exposure to real farming techniques and practices.</p>
          </div>

          <div className="program-card" data-aos="zoom-in" data-aos-delay="200">
            <h3>👨‍👩‍👧 Family Visits</h3>
            <p>Experience village life and nature with your loved ones.</p>
          </div>

          <div className="program-card" data-aos="zoom-in" data-aos-delay="300">
            <h3>🏢 Corporate Programs</h3>
            <p>Team building activities in a natural and refreshing environment.</p>
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="agri-section gallery">
        <h2 className="section-title" data-aos="fade-up">Amruthavanam Gallery</h2>

      <div className="gallery-grid">
  {[g1, g2, g3, g4, g5, g6, g7, g8, g9].map((img, i) => (
    <div 
      className="carousel-item" 
      key={i}
      onClick={() => setSelectedImage(img)}
      style={{ cursor: "pointer" }}
    >
      <img src={img} alt={`Gallery ${i + 1}`} />
    </div>
  ))}
</div>
      </section>

      {/* PAMPHLET & LOCATION */}
      <section className="agri-section pamphlet-location">
        <div className="pamphlet-location-container">
          
          {/* PAMPHLET CARD */}
          <div className="pamphlet-block" data-aos="fade-right">
            <h2 className="section-title">Amruthavanam Pamphlet</h2>
            <p className="subtitle-text">Click on any page to view full screen.</p>
            <div className="pamphlet-images">
              <div 
                className="pamphlet-card" 
                onClick={() => setSelectedImage(pamphletFront)}
              >
                <div className="pamphlet-img-wrapper">
                  <img src={pamphletFront} alt="Pamphlet Front" />
                </div>
              </div>
              <div 
                className="pamphlet-card" 
                onClick={() => setSelectedImage(pamphletBack)}
              >
                <div className="pamphlet-img-wrapper">
                  <img src={pamphletBack} alt="Pamphlet Back" />
                </div>
              </div>
            </div>
          </div>

          {/* MAP / LOCATION BLOCK */}
          <div className="location-block" data-aos="fade-left">
            <h2 className="section-title">Our Location</h2>
            <p className="subtitle-text">Visit us at Amruthavanam Agrifarm School.</p>
            <div className="map-wrapper">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3809.7354790431414!2d79.1145864!3d17.2800278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb3f461cd0ea31%3A0x44b0ffcd74092410!2sAmruthaVanam%20Agrifarm%20Resort!5e0!3m2!1sen!2sin!4v1780122742204!5m2!1sen!2sin" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Amruthavanam Agrifarm Resort Map"
              ></iframe>
            </div>
          </div>

        </div>
      </section>
    {selectedImage && (
  <div className="fullscreen-overlay" onClick={() => setSelectedImage(null)}>
    
    <span className="close-btn">&times;</span>

    <img 
      src={selectedImage} 
      alt="Full View" 
      className="fullscreen-image"
      onClick={(e) => e.stopPropagation()} 
    />
    
  </div>
)}
    </div>
  );
}
